/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React, {useState} from "react";
import PropTypes from "prop-types";

import GetStartedModal from "./GetStartedModal";

const propTypes = {
  rCode: PropTypes.string,
  resetPin: PropTypes.bool,
  setToggleModal: PropTypes.func,
  toggleModal: PropTypes.bool
};

const GetStartedModalContainer = ({
  setToggleModal,
  toggleModal,
  rCode,
  resetPin
}) => {
  const [userStep, setUserStep] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [rsessionId, setRsessionId] = useState("");
  const [userData, setUserData] = useState({});
  const [authRes, setAuthRes] = useState({});

  return (
    <GetStartedModal
      authRes={authRes}
      isLoading={isLoading}
      rCode={rCode}
      resetPin={resetPin}
      rsessionId={rsessionId}
      setAuthRes={setAuthRes}
      setIsLoading={setIsLoading}
      setRsessionId={setRsessionId}
      setToggleModal={setToggleModal}
      setUserData={setUserData}
      setUserStep={setUserStep}
      toggleModal={toggleModal}
      userData={userData}
      userStep={userStep}
    />
  );
};

GetStartedModalContainer.propTypes = propTypes;

export default GetStartedModalContainer;
